module.exports = __webpack_public_path__ + "img/toolbar_logo.68ddb646.png";